
































import CoText from '@/components/Atoms/co-text/CoText.vue';
import {
    SUPPORTED_IMAGE_MIME_TYPES,
    SUPPORTED_IMAGE_EXTENSIONS,
    normalizeAcceptedFileTypes,
} from '@/constants/fileUpload';

const DEFAULT_SUPPORTED_FILES = [...SUPPORTED_IMAGE_MIME_TYPES, ...SUPPORTED_IMAGE_EXTENSIONS];

export default {
    name: 'CoDragDropFileUpload',
    components: {
        CoText,
    },
    props: {
        title: {
            type: String,
            default: 'Drop file or click here',
        },
        subtitle: {
            type: String,
            default: 'Suggested size: 1000x1000px',
        },
        supportedFile: {
            type: [String, Array],
            default: () => [...DEFAULT_SUPPORTED_FILES],
        },
        multiple: {
            type: Boolean,
            default: false,
        },
    },
    mounted() {},
    data() {
        return {
            dragging: false,
            results: null,
        };
    },
    computed: {
        acceptedFileTypes() {
            if (Array.isArray(this.supportedFile)) {
                return this.supportedFile.join(',');
            }

            const supported = (this.supportedFile || '').trim();
            if (!supported) {
                return DEFAULT_SUPPORTED_FILES.join(',');
            }

            return this.supportedFile;
        },
        normalizedSupportedFileTypes() {
            const normalized = normalizeAcceptedFileTypes(this.supportedFile);
            if (normalized.length > 0) {
                return normalized;
            }

            return normalizeAcceptedFileTypes(DEFAULT_SUPPORTED_FILES);
        },
    },
    methods: {
        handleFileInput(event) {
            this.processFileInput(event.target.files);
            event.target.value = '';
        },
        handleDragOver(event) {
            event.stopPropagation();
            event.preventDefault();
            this.dragging = event.type === 'dragover';
            event.dataTransfer.dropEffect = 'copy';
        },
        handleFileSelect(event) {
            event.stopPropagation();
            event.preventDefault();
            this.dragging = false;
            this.processFileInput(event.dataTransfer.files);
        },
        processFileInput(files) {
            const supportedTypes = this.normalizedSupportedFileTypes;
            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                if (this.isFileSupported(file, supportedTypes)) {
                    const reader = new FileReader();
                    reader.onloadend = function () {
                        if (this.results === null) this.results = [];
                        const results = {
                            filePreview: reader.result,
                            file,
                        };
                        this.results.push(results);
                        this.$emit('handleInput', results);
                    }.bind(this);
                    reader.readAsDataURL(file);
                    if (!this.multiple) break;
                }
            }
        },
        clearResults() {
            this.results = null;
        },
        clickInput() {
            this.$refs.fileInput.click();
        },
        isFileSupported(file, supportedTypes) {
            if (!supportedTypes || supportedTypes.length === 0) {
                return true;
            }

            const fileType = (file?.type || '').toLowerCase();
            const fileName = (file?.name || '').toLowerCase();

            return supportedTypes.some((type) => {
                if (!type) return false;

                if (type.endsWith('/*')) {
                    return fileType.startsWith(type.replace('/*', '/'));
                }

                if (type.includes('*')) {
                    try {
                        const pattern = new RegExp(type);
                        return pattern.test(fileType) || pattern.test(fileName);
                    } catch (error) {
                        return false;
                    }
                }

                if (type.startsWith('.')) {
                    return fileName.endsWith(type);
                }

                return fileType === type;
            });
        },
    },
};
